import React from 'react';
import { IStats } from '../../utils';
import { Box, Heading, Table } from '../core';

interface GraphStatsProps {
  heading: string;
  stats: IStats | undefined;
}

export const GraphStats = ({ heading, stats }: GraphStatsProps) => {
  if (!stats) return null;
  const statsFmt = Object.keys(stats).map((key) => {
    let value = stats[key];
    if (typeof value === 'number' && (value >= 0.01 || value <= -0.01))
      value = value.toFixed(2) + '%';
    return {
      label: key,
      value,
    };
  });
  return (
    <Box mt={3}>
      <Heading as="h3" my={2}>
        {heading}
      </Heading>
      <Table
        columns={[1, 2]}
        index={false}
        data={statsFmt.map(({ label, value }) => [label, value?.toString?.()])}
      />
    </Box>
  );
};
